import supabase from '../lib/supabase';

// Sessions table operations
export async function createSupabaseSession(sessionData) {
  const { data, error } = await supabase
    .from('crossword_sessions_x7k2m9p1q4')
    .insert([{
      session_id: sessionData.id,
      clues: sessionData.clues,
      completion_message: sessionData.completionMessage,
      created_at: sessionData.createdAt,
      last_activity: sessionData.lastActivity
    }])
    .select();

  if (error) {
    console.error('Error creating session in Supabase:', error);
    throw error;
  }
  return data[0];
}

export async function getSupabaseSession(sessionId) {
  const { data, error } = await supabase
    .from('crossword_sessions_x7k2m9p1q4')
    .select('*')
    .eq('session_id', sessionId)
    .single();

  if (error && error.code !== 'PGRST116') {
    console.error('Error getting session from Supabase:', error);
    throw error;
  }
  
  if (data) {
    // Update last activity
    await updateSupabaseSessionActivity(sessionId);
    
    return {
      id: data.session_id,
      clues: data.clues,
      completionMessage: data.completion_message,
      createdAt: data.created_at,
      lastActivity: data.last_activity
    };
  }
  
  return null;
}

export async function updateSupabaseSession(sessionId, sessionData) {
  const { data, error } = await supabase
    .from('crossword_sessions_x7k2m9p1q4')
    .update({
      clues: sessionData.clues,
      completion_message: sessionData.completionMessage,
      last_activity: sessionData.lastActivity
    })
    .eq('session_id', sessionId)
    .select();

  if (error) {
    console.error('Error updating session in Supabase:', error);
    throw error;
  }
  return data[0];
}

export async function deleteSupabaseSession(sessionId) {
  const { error } = await supabase
    .from('crossword_sessions_x7k2m9p1q4')
    .delete()
    .eq('session_id', sessionId);

  if (error) {
    console.error('Error deleting session from Supabase:', error);
    throw error;
  }
  return true;
}

export async function updateSupabaseSessionActivity(sessionId) {
  const { data, error } = await supabase
    .from('crossword_sessions_x7k2m9p1q4')
    .update({
      last_activity: new Date().toISOString()
    })
    .eq('session_id', sessionId)
    .select();

  if (error) {
    console.error('Error updating session activity in Supabase:', error);
    throw error;
  }
  return data[0];
}

// Initialize database table
export async function initializeSupabaseTable() {
  try {
    // This function would be called to set up the table if needed
    // In production, this should be done via Supabase migrations
    console.log('Supabase table should be initialized via migrations');
  } catch (error) {
    console.error('Error initializing Supabase table:', error);
  }
}